import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ParticleBackground from "@/components/ParticleBackground";
import AIGrid from "@/components/AIGrid";
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";

const Imprint = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background relative overflow-hidden">
      <ParticleBackground />
      <AIGrid />
      <Navigation />

      <main className="flex-grow pt-32 pb-20 relative z-10">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-4">Imprint</h1>
            <p className="text-muted-foreground text-lg">Legal information and company details</p>
          </motion.div>

          <Card className="p-8 glass-effect border-primary/30 max-w-4xl mx-auto">
            <div className="space-y-6 text-sm leading-relaxed text-muted-foreground">
              <section>
                <h2 className="text-xl font-semibold mb-4">Information according to § 5 TMG:</h2>
                <div className="space-y-2">
                  <p><strong>Company:</strong> Holionix GmbH</p>
                  <p><strong>Address:</strong><br />
                    Ruth-Hallensleben-Straße 14<br />
                    50739 Cologne
                  </p>
                  <p><strong>Contact:</strong><br />
                    Telephone: +49 15216724688<br />
                    Email: info@holionix.de
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">Legal Representation:</h2>
                <div className="space-y-2">
                  <p><strong>Represented by:</strong> Pooja Upadhyay</p>
                  <p><strong>VAT ID:</strong> DE456519116</p>
                  <p><strong>Commercial Register:</strong> HRB 123600</p>
                  <p><strong>Supervisory authority:</strong> Cologne Chamber of Commerce and Industry</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">EU Dispute Resolution:</h2>
                <div className="space-y-2">
                  <p>The European Commission provides a platform for online dispute resolution (ODR):</p>
                  <p><a href="https://ec.europa.eu/consumers/odr" className="text-primary hover:text-accent transition-colors" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a></p>
                  <p>You can find our email address in the legal notice above.</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">Consumer Dispute Resolution:</h2>
                <p>We are neither obligated nor willing to participate in dispute resolution proceedings before a consumer arbitration board.</p>
              </section>

              <div className="text-xs mt-8 pt-4 border-t border-muted">
                <p>Last updated: November 3, 2025</p>
              </div>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Imprint;


